import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-900">
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 p-12 relative overflow-hidden grain">
        <Link to="/"><Logo size="md" light /></Link>
        <div>
          <h2 className="font-heading text-3xl font-bold text-white leading-tight">{t("hero_title")}</h2>
          <p className="mt-4 text-slate-300 max-w-md">{t("hero_sub")}</p>
        </div>
        <p className="text-sm text-blue-200 font-medium">{t("hero_sub")}</p>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8"><Link to="/"><Logo size="md" /></Link></div>
          <h1 className="font-heading text-2xl font-bold text-white">{t("login_title")}</h1>
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">{t("email")}</Label>
              <Input id="email" type="email" required value={email} data-testid="login-email-input"
                onChange={(e) => setEmail(e.target.value)} placeholder="nome@azienda.it" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">{t("password")}</Label>
              <Input id="password" type="password" required value={password} data-testid="login-password-input"
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <Button type="submit" className="w-full h-11" disabled={loading} data-testid="login-submit-btn">
              {loading ? "…" : t("login_btn")}
            </Button>
          </form>
          <p className="mt-6 text-sm text-slate-300">
            {t("no_account")}{" "}
            <Link to="/register" className="font-semibold text-blue-600 hover:underline" data-testid="to-register-link">
              {t("register_btn")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
